var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartphoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#BFDFF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.9997H12.5067M9.16671 5.33301H15.8334C16.5698 5.33301 17.1667 5.92996 17.1667 6.66634V17.333C17.1667 18.0694 16.5698 18.6663 15.8334 18.6663H9.16671C8.43033 18.6663 7.83337 18.0694 7.83337 17.333V6.66634C7.83337 5.92996 8.43033 5.33301 9.16671 5.33301Z",
    stroke: "#2D97E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphoneIcon);
export default __webpack_public_path__ + "static/media/smartphone-icon.d99d54275f31e974222983f972a4060f.svg";
export { ForwardRef as ReactComponent };